import React from 'react';
import { Link } from 'react-router-dom';

const CTABanner = () => (
  <section style={{ position:'relative', overflow:'hidden' }}>
    <div style={{
      position:'absolute', inset:0,
      backgroundImage:`url('https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1800&auto=format&fit=crop&q=70')`,
      backgroundSize:'cover', backgroundPosition:'center',
      filter:'brightness(0.28) saturate(0.5)',
    }} />
    <div style={{ position:'absolute', inset:0, background:'rgba(28,21,16,0.5)' }} />
    <div className="container position-relative text-center" style={{ zIndex:1, padding:'100px 0' }}>
      <span className="section-label">Ready to Begin</span>
      <h2 style={{ fontFamily:'var(--font-disp)', fontSize:'clamp(3rem,7vw,6rem)', fontWeight:400, color:'var(--cream2)', lineHeight:1, marginBottom:'1.5rem', letterSpacing:'-0.02em' }}>
        Let's Build Something<br/><em style={{ color:'var(--tan)' }}>Extraordinary</em>
      </h2>
      <p style={{ color:'rgba(232,221,208,0.6)', fontSize:'0.9rem', lineHeight:1.85, maxWidth:480, margin:'0 auto 2.5rem', fontWeight:300 }}>
        Get a free consultation and detailed project estimate within 24 hours. Our studio is ready to craft your vision.
      </p>
      <div className="d-flex flex-wrap gap-4 justify-content-center">
        <Link to="/contact" className="btn-warm-solid">
          Start a Project
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.2"/></svg>
        </Link>
        <Link to="/portfolio" className="btn-warm"><span>View Our Work</span></Link>
      </div>
    </div>
  </section>
);

export default CTABanner;
